import { createFileRoute } from "@tanstack/react-router";
import VirtualEducationPage from "@/pages/VirtualEducationPage";

/**
 * Index page for /virtual-education. Moved out of the parent route so the
 * parent can act as a layout that renders <Outlet /> for nested children
 * (e.g. /virtual-education/saint-tms-explained).
 */
export const Route = createFileRoute("/virtual-education/")({
  head() {
    return {
      meta: [
        {
          title: "Virtual Education | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Watch virtual education videos, expert webinars, and physician explainers on SAINT® TMS, SPRAVATO®, IV Ketamine, and advanced neuromodulation.",
        },
        {
          property: "og:title",
          content: "Virtual Education | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Watch virtual education videos, expert webinars, and physician explainers on SAINT® TMS, SPRAVATO®, IV Ketamine, and advanced neuromodulation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/virtual-education",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/virtual-education",
        },
      ],
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <VirtualEducationPage />;
}
